// Feature announcements shown as dismissible banners on the dashboards.
//
// To announce a new feature, add ONE entry to the top of this array:
//   id:       unique, stable string — NEVER reuse or change once shipped
//             (it's the per-user "dismissed" key). Suffix with the date.
//   audience: 'all' | 'admin' | 'therapist'  (who sees it)
//   icon:     emoji shown before the title
//   title:    short bold lead-in
//   text:     the message
//
// Banners are dismissed per-user in the browser (localStorage). They appear on
// the next dashboard load/login, not on a page that's already open.
export const ANNOUNCEMENTS = [
  {
    id: 'sent-links-2026-06-24',
    audience: 'therapist',
    icon: '🔗',
    title: 'New: Sent Links',
    text: "Track the welcome/intake and ROI links you've sent under My Clients → Sent Links — and you'll get a banner here when a client completes one.",
  },
  {
    id: 'payment-links-2026-06-24',
    audience: 'admin',
    icon: '💳',
    title: 'New: Payment Links',
    text: 'See the status of every card-collection link, and email card-update links, under Collections → Payment Links.',
  },
];
